/*
 * Rabattfortschritt (Anpassung dotSHOP, eigene Datei).
 * Spezifikation: shopify-toolkit/playbook/rabattfortschritt.md
 *
 * Datenquelle: shop.metafields.konditionen.schwellen (make schwellen).
 * Bezugsgroessen, im Warenkorb belegt:
 *   - Rabattschwellen greifen auf den Listenwert; kombinierbare Rabatte
 *     addieren sich, von nicht kombinierbaren nimmt Shopify den hoechsten.
 *   - Versandschwellen greifen auf den Warenwert nach Rabatt.
 * Angezeigt wird immer, was der Kunde noch in LISTENPREISEN in den Korb
 * legen muss.
 */
(function (global) {
  'use strict';

  var CENT = 0.005;

  function aktiveRabatte(rabatte, jetzt) {
    return (rabatte || []).filter(function (r) {
      if (r.beginnt && new Date(r.beginnt) > jetzt) return false;
      if (r.endet && new Date(r.endet) <= jetzt) return false;
      return r.prozent > 0;
    });
  }

  /** Rabattsatz (0..1) beim Listenwert w. */
  function satz(rabatte, w) {
    var summe = 0, einzeln = 0;
    rabatte.forEach(function (r) {
      if (r.ab > w + CENT) return;
      if (r.kombinierbar) summe += r.prozent; else einzeln = Math.max(einzeln, r.prozent);
    });
    return Math.max(summe, einzeln) / 100;
  }

  function nachRabatt(rabatte, w) { return w * (1 - satz(rabatte, w)); }

  /** Kleinster Listenwert >= w, bei dem der Wert nach Rabatt >= ziel ist. */
  function listenwertFuer(rabatte, w, ziel) {
    var grenzen = [0].concat(rabatte.map(function (r) { return r.ab; }))
      .filter(function (a, i, x) { return x.indexOf(a) === i; })
      .sort(function (a, b) { return a - b; });
    for (var i = 0; i < grenzen.length; i++) {
      var von = grenzen[i], bis = i + 1 < grenzen.length ? grenzen[i + 1] : Infinity;
      if (bis <= w) continue;
      var s = satz(rabatte, Math.max(von, w));
      var kandidat = Math.max(von, w, Math.ceil((ziel / (1 - s)) * 100 - 1e-6) / 100);
      if (kandidat < bis && nachRabatt(rabatte, kandidat) >= ziel - CENT) return kandidat;
    }
    return null;
  }

  function versandStufe(versand, v) {
    var treffer = null;
    (versand || []).forEach(function (s) {
      if (s.ab <= v + CENT && (s.bis == null || v <= s.bis + CENT)) {
        if (!treffer || s.preis < treffer.preis) treffer = s;
      }
    });
    return treffer;
  }

  /**
   * Was als naechstes kommt.
   *   { art: 'lieferung'|'versandfrei'|'rabatt'|'erreicht'|'nichts',
   *     fehlt, ziel, von, prozent, ersparnis, satzJetzt, kombiniert }
   */
  function naechstes(schwellen, w, jetzt) {
    jetzt = jetzt || new Date();
    var rabatte = aktiveRabatte(schwellen && schwellen.rabatte, jetzt);
    var versand = (schwellen && schwellen.versand) || [];
    if (!rabatte.length && !versand.length) return { art: 'nichts' };

    var v = nachRabatt(rabatte, w);
    var stufe = versandStufe(versand, v);
    var satzJetzt = satz(rabatte, w);
    var kandidaten = [];

    // Versand: naechst guenstigere Stufe (oder ueberhaupt eine Lieferung)
    versand.filter(function (s) { return s.ab > v + CENT; })
      .sort(function (a, b) { return a.ab - b.ab; })
      .forEach(function (s) {
        if (stufe && s.preis >= stufe.preis) return;
        var ziel = listenwertFuer(rabatte, w, s.ab);
        if (ziel == null) return;
        kandidaten.push({
          art: stufe ? 'versandfrei' : 'lieferung',
          ziel: ziel, fehlt: ziel - w, preis: s.preis,
          ersparnis: stufe ? stufe.preis - s.preis : 0,
          nachRabattGerechnet: satzJetzt > 0,
        });
      });

    // Rabatt: naechste Schwelle, an der der Satz steigt
    rabatte.map(function (r) { return r.ab; })
      .filter(function (a) { return a > w + CENT; })
      .sort(function (a, b) { return a - b; })
      .forEach(function (a) {
        var neu = satz(rabatte, a);
        if (neu <= satzJetzt) return;
        if (kandidaten.some(function (k) { return k.art === 'rabatt'; })) return;
        var ersparnis = nachRabatt(rabatte, w) + (a - w) - nachRabatt(rabatte, a);
        kandidaten.push({ art: 'rabatt', ziel: a, fehlt: a - w, prozent: Math.round(neu * 1000) / 10, ersparnis: ersparnis });
      });

    if (!kandidaten.length) return { art: 'erreicht', satzJetzt: satzJetzt, versandfrei: !!(stufe && stufe.preis === 0), mitRabatt: rabatte.length > 0 };

    // Ohne Lieferung zaehlt nichts anderes. Sonst: die naechste Schwelle.
    var lieferung = kandidaten.filter(function (k) { return k.art === 'lieferung'; })[0];
    kandidaten.sort(function (a, b) { return a.fehlt - b.fehlt; });
    var erstes = lieferung || kandidaten[0];

    // Zwei Schwellen fast gleichauf: eine Aussage daraus machen
    var zweites = kandidaten.filter(function (k) { return k !== erstes && Math.abs(k.fehlt - erstes.fehlt) <= 10; })[0];
    if (zweites) erstes.kombiniert = zweites;

    // Balken: vom letzten erreichten Punkt bis zum Ziel
    var punkte = [0].concat(rabatte.map(function (r) { return r.ab; }));
    versand.forEach(function (s) { var z = listenwertFuer(rabatte, 0, s.ab); if (z != null) punkte.push(z); });
    erstes.von = Math.max.apply(null, punkte.filter(function (p) { return p <= w + CENT; }));
    erstes.satzJetzt = satzJetzt;
    return erstes;
  }

  global.Rabattfortschritt = { satz: satz, nachRabatt: nachRabatt, listenwertFuer: listenwertFuer, naechstes: naechstes, aktiveRabatte: aktiveRabatte };

  // ---------------------------------------------------------------- Anzeige
  if (typeof document === 'undefined') return;

  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  function fuelle(text, werte) {
    return String(text || '').replace(/\[(\w+)\]/g, function (_, k) { return werte[k] != null ? werte[k] : ''; });
  }

  function satzText(el, e, t) {
    if (e.art === 'lieferung') return fuelle(t.lieferung, { betrag: euro.format(e.fehlt), versand: euro.format(e.preis) });
    if (e.art === 'versandfrei') return fuelle(t.versandfrei, { betrag: euro.format(e.fehlt), ersparnis: euro.format(e.ersparnis) });
    if (e.art === 'rabatt') {
      var s = fuelle(t.rabatt, { betrag: euro.format(e.fehlt), prozent: String(e.prozent).replace('.', ',') });
      if (e.ersparnis >= 1) s += fuelle(t.ersparnis, { ersparnis: euro.format(e.ersparnis) });
      return s;
    }
    return '';
  }

  function zeichne(el, w) {
    var t = JSON.parse(el.getAttribute('data-texte'));
    var schwellen = JSON.parse(el.getAttribute('data-schwellen') || 'null');
    var e = naechstes(schwellen, w);
    var satzEl = el.querySelector('[data-satz]');
    var hinweisEl = el.querySelector('[data-hinweis]');
    var balken = el.querySelector('[data-balken]');

    if (e.art === 'nichts' || w <= 0) { el.hidden = true; return; }
    el.hidden = false;

    if (e.art === 'erreicht') {
      satzEl.textContent = e.mitRabatt ? (e.versandfrei ? t.erreicht : t.erreicht_rabatt) : t.erreicht_versand;
      hinweisEl.textContent = '';
      balken.style.width = '100%';
      return;
    }
    var text = satzText(el, e, t);
    if (e.kombiniert) {
      var k = e.kombiniert;
      var kurz = k.art === 'rabatt' ? fuelle(t.kurz_rabatt, { prozent: String(k.prozent).replace('.', ',') }) : (k.art === 'versandfrei' ? t.kurz_versandfrei : t.kurz_lieferung);
      text += fuelle(t.und, { weiteres: kurz });
    }
    var ort = el.getAttribute('data-ort');
    var vorsatz = ort === 'produkt' ? t.mit_artikel : ort === 'konfigurator' ? (t.mit_konfiguration || '') : '';
    satzEl.textContent = '';
    // Vorsatz als eigenes Element: Der Konfigurator kann ihn so in eine eigene Zeile stellen
    if (vorsatz) {
      var v = document.createElement('span');
      v.className = 'rabattfortschritt__vorsatz';
      v.textContent = vorsatz;
      satzEl.appendChild(v);
    }
    satzEl.appendChild(document.createTextNode(text));
    hinweisEl.textContent = (e.art !== 'rabatt' && e.nachRabattGerechnet) ? fuelle(t.nach_rabatt, { prozent: String(Math.round(e.satzJetzt * 1000) / 10).replace('.', ',') }) : '';
    var anteil = e.ziel > e.von ? (w - e.von) / (e.ziel - e.von) : 1;
    balken.style.width = Math.max(4, Math.min(100, Math.round(anteil * 100))) + '%';
  }

  function korbwert() {
    return fetch((global.routes && global.routes.cart_url ? global.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.original_total_price / 100; });
  }

  function wertVon(el) {
    var ort = el.getAttribute('data-ort');
    return el._korb + (ort === 'produkt' || ort === 'konfigurator' ? el._artikel * el._menge : 0);
  }

  /** Einen Baustein anwerfen. Dawn baut den Summenbereich im Warenkorb bei
      jeder Mengenaenderung neu auf - der neue Baustein kommt mit frischem
      data-korb vom Server und wird hier nachtraeglich angeworfen. */
  function anwerfen(el) {
    if (el._rf) return;
    el._rf = true;
    el._korb = Number(el.getAttribute('data-korb')) / 100;
    el._artikel = Number(el.getAttribute('data-artikel') || 0) / 100;
    el._menge = 1;
    el._neu = function () { zeichne(el, wertVon(el)); };
    el._neu();
    if (el.getAttribute('data-ort') === 'produkt') {
      var bereich = el.closest('section') || document;
      // 'input' fuer das Eintippen, 'change' fuer die Plus-/Minus-Knoepfe
      var mengeNeu = function (ev) {
        if (ev.target && ev.target.name === 'quantity') { el._menge = Math.max(1, Number(ev.target.value) || 1); el._neu(); }
      };
      bereich.addEventListener('input', mengeNeu);
      bereich.addEventListener('change', mengeNeu);
    }
  }

  function alle() { return document.querySelectorAll('[data-rabattfortschritt]'); }

  /**
   * Konfigurator (k5fence-App, auf einer Shopify-Seite eingebettet): Die App
   * stellt einen leeren Platz bereit und meldet den Listenpreis der
   * Konfiguration in Euro. Schwellen, Texte und Korbwert kommen aus der
   * Vorlage, die das Theme auf jeder Seite rendert
   * ([data-rabattfortschritt-vorlage]). Gestaltung und Rechnung sind damit
   * dieselben wie im Shop.
   *   Rabattfortschritt.konfigurator(platz, { wert: 1234.5, kurz: false })
   * Rueckgabe false, wenn die Seite keine Vorlage hat.
   */
  function konfigurator(platz, angaben) {
    if (!platz) return false;
    angaben = angaben || {};
    var el = platz.querySelector('[data-rabattfortschritt]');
    if (!el) {
      var vorlage = document.querySelector('[data-rabattfortschritt-vorlage]');
      if (!vorlage) return false;
      el = vorlage.cloneNode(true);
      el.removeAttribute('data-rabattfortschritt-vorlage');
      el.setAttribute('data-rabattfortschritt', '');
      if (angaben.kurz) el.classList.add('rabattfortschritt--kurz');
      platz.appendChild(el);
      anwerfen(el);
    }
    el._artikel = Math.max(0, Number(angaben.wert) || 0);
    el._menge = 1;
    el._neu();
    return true;
  }
  global.Rabattfortschritt.konfigurator = konfigurator;

  function start() {
    if (global.__rabattfortschrittLaeuft) return;
    global.__rabattfortschrittLaeuft = true;
    alle().forEach(anwerfen);
    // Fuer eingebettete Apps, die vor diesem Skript geladen haben
    document.dispatchEvent(new CustomEvent('rabattfortschritt:bereit'));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        alle().forEach(anwerfen);
        korbwert().then(function (k) { alle().forEach(function (el) { el._korb = k; el._neu(); }); });
      });
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v) return;
        alle().forEach(function (el) { if (el.getAttribute('data-ort') === 'produkt') { el._artikel = v.price / 100; el._neu(); } });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})(typeof window !== 'undefined' ? window : globalThis);
